<div
	[editableInStoryblok]="_editable"
	[ngClass]="{ 'h-full': !stopGrow() }"
	class="w-full"
>
	@if (components) {
		@let heading = headingInputs()[0];
		@let button = buttons();
		<vp-persuade-card
			[cardUrl]="button?.secondaryCtaUrl"
			[ctaText]="button?.ctaText"
			[ctaType]="button?.ctaType ? button.ctaType : 'btn-primary'"
			[ctaUrl]="button?.ctaUrl"
			[headingType]="heading?.headingType"
			[images]="flatImages()"
			[linkListConfig]="linkList()"
			[overline]="heading?.overline"
			[secondaryCtaText]="button?.secondaryCtaText"
			[title]="heading?.title"
			[useVerticalCard]="!isHorizontal()"
			imageVariant="grid"
		>
			<ng-container content>
				@for (blok of contentInputs(); track $index) {
					<ndc-dynamic
						[ndcDynamicComponent]="components[blok['component']]"
						[ndcDynamicInputs]="blok"
						class="hidden"
					/>
				}
			</ng-container>
		</vp-persuade-card>
	}
</div>
